// 邀请链接的对象类型与展示编号分开保存，允许代理和会员使用相同编号。
export function parseInvitation(value) {
  const code = typeof value === 'string' ? value.trim() : '';
  const match = /^(agent|member):(.*)$/.exec(code);
  return { kind: match?.[1] || (code ? '' : 'agent'), code: match ? match[2].trim() : code };
}

export function registrationInvitationCode(value, kind = '') {
  const code = typeof value === 'string' ? value.trim() : '';
  if (!code || !kind) return code;
  const invitation = parseInvitation(code);
  return `${kind}:${invitation.code}`;
}
